import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

const QueryKey = {
	ActiveFlashPointsProgram: 'active-flash-points-program',
};

export enum Status {
	Active = 'active',
	Archived = 'archived',
	Expired = 'expired',
	Upcoming = 'upcoming',
}

export type FlashPointsProgram = {
	id: string;
	accentColor: string;
	baseColor: string;
	createdByUser: {
		id: string;
		displayName: string;
	};
	deletedAt: string | null;
	description: string;
	endDate: string;
	expirationManuallyOverruled: boolean;
	givingRate?: string;
	headline: string;
	name: string;
	pointsPerUser: number;
	startDate: string;
	status: Status;
};

interface GetAllFlashPointsResponse {
	records: FlashPointsProgram[];
}

export type SortDirection = 'ASC' | 'DESC';

export const useGetActiveFlashPointsProgram = (flash_points_balance?: number) => {
	const http = useHttpClient('v2');

	return useQuery(
		[QueryKey.ActiveFlashPointsProgram],
		async () => {
			const res = await http.get<GetAllFlashPointsResponse>(`/programs/flash_points`, {
				params: { status: 'active' },
				headers: {
					'Key-Inflection': 'camel',
				},
			});
			return res.data.records[0];
		},
		{
			enabled: !!flash_points_balance,
			retry: false,
			refetchOnWindowFocus: false,
		}
	);
};
